module.exports = "/_next/static/images/DashboardUnderstand@2x-c1f35e980e3f41d8615b7e707d9ddff3.webp";